<template>
	<div
		class="comment-body"
		v-html="content"
	/>
</template>

<script setup>
const { content } = defineProps({
  content: {
    type: String, 
    required: true
  }
});
</script>

<style lang="scss">
@import "@assets/utils.scss";

.comment-body {
	width: 100%;
}
.comment-body p {
	color: $neutral-800;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;

	a {
		white-space: normal;
		word-wrap: break-word;
	}
}
</style>
